import React, { useState } from "react"; 
import "./contactlens.css";

function ContactLens() {
  // Define an array of contact lens details
  const initialContactLensData = [
    { id: 1, name: "Colored Contact Lenses - Aquamarine", price: 6000, image: "/Colored Contact Lenses - Aquamarine 6000.jpg" },
    { id: 2, name: "Colored Contact Lenses - Indigo", price: 6000, image: "/Colored Contact Lenses - Indigo  -  6000.jpg" },
    { id: 3, name: "Colored Contact Lenses - Dark Hazel", price: 6000, image: "/Colored Contact Lenses - Dark Hazel 6000.jpg" },
    { id: 4, name: "Colored Contact Lenses - Jade", price: 6000, image: "/Colored Contact Lenses - Jade 6000.jpg" },
    { id: 5, name: "Colored Contact Lenses - Platinum", price: 6000, image: "/Colored Contact Lenses - Platinum 6000.jpg" },
    { id: 6, name: "Bausch & Lomb Colored+Powered Contact Lenses", price: 6500, image: "/Bausch & Lomb Colored+Powered Contact Lenses 6500.jpg" },
    { id: 7, name: "Bausch + Lomb SofLens59 Monthly Disposable Contact Lenses (Powered)", price: 8500, image: "/Bausch + Lomb SofLens59 Monthly Disposable Contact Lenses (Powered) - 8500.jpg"},
    { id: 8, name: "Bausch + Lomb SofLens Daily Disposable 30 Pack (Powered)", price: 12000, image: "/Bausch + Lomb SofLens Daily Disposable 30 Pack (Powered) - 12000.jpg"},
    { id: 9, name: "Bausch + Lomb PureVision 2", price: 15000, image: "/Bausch + Lomb PureVision 2 15000.jpg" },

  ];

  // Load cart from localStorage on initial render
  const [cart, setCart] = useState(JSON.parse(localStorage.getItem("cart")) || []);
  
  const handleAddToCart = (product) => {
    const existingProduct = cart.find(item => item.id === product.id);
    if (existingProduct) {
      const updatedCart = cart.map(item =>
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      );
      setCart(updatedCart);
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    } else {
      const newCart = [...cart, { ...product, quantity: 1 }];
      setCart(newCart);
      localStorage.setItem("cart", JSON.stringify(newCart));
    }
    
    // Show alert when product is added
    alert(`${product.name} has been added to the cart!`);
  };

  const [contactLensData, setContactLensData] = useState(initialContactLensData);

  // Sorting logic
  const handleSort = (criteria) => {
    const sortedData = [...contactLensData].sort((a, b) => {
      if (criteria === "name") {
        return a.name.localeCompare(b.name);
      } else if (criteria === "price") {
        return a.price - b.price;
      }
      return 0;
    });
    setContactLensData(sortedData);
  };

  return (
    <div className="contactlens-container">
      <h1>Contact Lenses</h1>
      <p>Explore our wide range of high-quality contact lenses for every need.</p>

      {/* Sorting Dropdown */}
      <div className="sorting-dropdown">
        <label htmlFor="sortOptions">Sort by: </label>
        <select
          id="sortOptions"
          onChange={(e) => handleSort(e.target.value)}
          className="sort-select"
        >
          <option value="">Select</option>
          <option value="name">Name</option>
          <option value="price">Price</option>
       
        </select>
      </div>

      {/* Contact Lens Grid */}
      <div className="contactlens-grid">
        {contactLensData.map((lens, index) => (
          <div key={index} className="contactlens-item">
            <img
              src={lens.image}
              alt={lens.name}
              className="contactlens-image"
            />
            <h2 className="contactlens-name">{lens.name}</h2>
            <p className="contactlens-price">Rs. {lens.price.toLocaleString()}</p>
            <button
              className="add-to-cart-contactlens"
              onClick={() => handleAddToCart(lens)}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContactLens;
